import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { TECH_PARTNERS } from "@/lib/data";

const PartnerTile = ({ partner, idx }) => {
    return (
        <motion.div
            initial={{ opacity: 0, y: 12 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-40px" }}
            transition={{ duration: 0.4, delay: (idx % 12) * 0.03 }}
        >
            <Link
                to={partner.slug ? `/partners/${partner.slug}` : "/partners"}
                className="group aspect-[3/2] sxe-card flex items-center justify-center p-4"
                data-testid={`partner-tile-${idx}`}
                title={partner.name}
            >
                {partner.logo ? (
                    <img
                        src={partner.logo}
                        alt={partner.name}
                        loading="lazy"
                        className="h-9 w-auto max-w-[75%] object-contain opacity-80 group-hover:opacity-100 transition-opacity"
                        style={partner.mono ? { filter: "brightness(0) invert(1)" } : undefined}
                        onError={(e) => { e.currentTarget.style.display = "none"; }}
                    />
                ) : (
                    <span className="font-display font-semibold tracking-[-0.02em] text-white/80 group-hover:text-white transition-colors text-center text-[15px] leading-tight">
                        {partner.name}
                    </span>
                )}
            </Link>
        </motion.div>
    );
};

const TechPartners = () => (
    <section data-testid="partners-section" className="sxe-section relative">
        <div className="sxe-container">
            <div className="flex flex-col md:flex-row md:items-end justify-between gap-6">
                <div className="max-w-2xl">
                    <div className="overline"><span className="dot" /> Technology Partners</div>
                    <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-medium tracking-tighter leading-[1.05] text-white mt-5">
                        28+ global partners.{" "}
                        <span className="text-gradient">One certified stack.</span>
                    </h2>
                    <p className="text-[#B0A3C4] text-lg leading-relaxed mt-5">
                        SpringXE&apos;s programs and certifications are aligned with the world&apos;s leading technology and standards bodies — so your teams learn on the platforms they&apos;ll actually use.
                    </p>
                </div>
                <Link to="/partners" data-testid="partners-explore-all-btn" className="btn-secondary shrink-0">
                    Explore All Partners <ArrowUpRight className="w-4 h-4" />
                </Link>
            </div>

            <div className="mt-12 grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 lg:grid-cols-7 gap-3">
                {TECH_PARTNERS.map((p, i) => (
                    <PartnerTile key={p.name} partner={p} idx={i} />
                ))}
            </div>
        </div>
    </section>
);

export default TechPartners;
